import { INQUIRY_TYPES } from "store/types";
import { refactorInquiryObj } from "utils/misc";

const INITIAL_STATE = {
  inquiries: null,
  inquiry: {},
};

const inquiryReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case INQUIRY_TYPES.FETCH_INQUIRY_SUCCESS:
      return {
        ...state,
        inquiries: refactorInquiryObj(action.payload),
      };
    case INQUIRY_TYPES.FETCH_INQUIRY_BYID_SUCCESS:
      return {
        ...state,
        inquiry: action.payload,
      };
    default:
      return state;
  }
};

export default inquiryReducer;
